module.exports = __webpack_public_path__ + "img/tn-stock-2.d40cff7f.jpeg";